import { Navigate, Outlet, useNavigate } from 'react-router';
import { AppShell } from '@inexture/core';
import AdminHeader from '@components/admin/header/AdminHeader.tsx';
import AdminSidebar from '@components/admin/sidebar/AdminSidebar.tsx';
import { useAppDispatch, useAppSelector } from '@/store';
import { GET_AUTH_CONFIG, RESET_AUTH_TOKEN } from '@/store/app/auth.slice.ts';
import { useEffect } from 'react';

const AdminLayout = () => {
  const { isLoggedIn, token } = useAppSelector(GET_AUTH_CONFIG);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const expiredToken = token?.expires && new Date(token.expires) < new Date();

  useEffect(() => {
    if (isLoggedIn && expiredToken) {
      dispatch(RESET_AUTH_TOKEN());
      navigate('/auth/login', { replace: true });
    }
  }, [isLoggedIn, expiredToken, dispatch, navigate]);

  if (!isLoggedIn || expiredToken) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <AppShell
      withBorder={false}
      header={{ height: 60 }}
      navbar={{ width: 200, breakpoint: 'sm', collapsed: { mobile: true } }}
      padding={0}
      styles={{
        header: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '1rem',
          boxShadow: 'var(--mantine-shadow-md)',
          backgroundColor: 'var(--mantine-primary-color-9)'
        },
        navbar: {
          backgroundColor: 'var(--mantine-primary-color-8)'
        },
        main: {
          backgroundColor: 'var(--mantine-color-gray-3)'
        }
      }}
    >
      <AppShell.Header>
        <AdminHeader />
      </AppShell.Header>
      <AppShell.Navbar>
        <AdminSidebar />
      </AppShell.Navbar>
      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
};

export default AdminLayout;
